import _, { transform } from 'lodash';
import moment from 'moment';
import tinymce from 'tinymce';

let dt_index = null;
let dt_import_contents = null;
let content_type = '';
let content_date = '';
let content_address = '';
let calendars = [];
let types_visibility = [];
let section_options = [];
let block_options = [];
let background_colors = [];
let dt_categories = null;
let dt_tags = null;
let dt_calendars = null;
let dt_media = null;
let dt_comments = null;

export let blocks = {
    row: require('./blocks/row'),
    title: require('./blocks/title'),
    textarea: require('./blocks/textarea'),
    image: require('./blocks/image'),
    video: require('./blocks/video'),
    index: require('./blocks/index'),
    button: require('./blocks/button'),
    form: require('./blocks/form'),
    calendar: require('./blocks/calendar'),
    slider: require('./blocks/slider'),
    external_video: require('./blocks/external_video'),
    slider_images: require('./blocks/slider_images'),
    divider: require('./blocks/divider'),
    program: require('./blocks/program'),
    speakers: require('./blocks/speakers'),
    gallery: require('./blocks/gallery')
};

let content_versions = require('./content_versions');

window._blocks_device = 'xl';

// index

export function index(params){

    content_type = params.content_type;
    let table_columns = [
        { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
        { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_contents_actions },
        { width: '20', data: 'visibility', class: 'px-0', orderable: false, searchable: false , render: render_contents_visible},
        { data: 'title', orderable: true, searchable: true },
        { width: '100', data: 'status', orderable: true, searchable: true },
    ]

    let table_order = [3, 'asc'];

    if (content_type != 'page' && content_type != 'index') {
        table_columns.push({ width: '100', data: 'published_at', orderable: true, searchable: true, render: datatables.render_date});
        table_order = [5, 'desc'];
        if (content_type == 'calendar_entry') {
            table_columns.push({ width: '100', data: 'date_start', orderable: true, searchable: true, render: datatables.render_datetime});
            table_order = [6, 'desc'];
        }
    }

    table_columns.push({ width: '100', data: 'comments_count', orderable: true, searchable: true});
    table_columns.push({ width: '100', data: 'last_comment_date', orderable: true, searchable: true});

        
    dt_index = $('#contents_table').DataTable({
        ajax: {
            url: $('#contents_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: table_columns,
        order: table_order,
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_contents"]').click(batch_delete_contents);
    });

    window.microsite_id = params.microsite_id;
    show_init_import_contents();
}

function render_contents_actions(data, type, row){

    const url_info = ($("#contents_table").attr('url_info') ?? '').replace('#', row.id).replace('~', content_type);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

function render_contents_visible(data, type, row){
    return '<div class="btn-group" role="group">' + visibility_button(row.visible, window.__(row.visibility)) + '</div>';
}

function batch_delete_contents(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.contents.batch_delete'].replace('{microsite}', window.microsite_id);
    
    let contents_id = [];
    $.each(rows_selected, function(index, rowId){
        contents_id.push(rowId);
    });
    
    if(contents_id.length == 0){

        window.messages.error(__('No has seleccionado ningún contenido'));

    } else {

        const title = __('Eliminar contenidos');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un contenido.|[2,*] Estás a punto de eliminar :count contenidos.', contents_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', window.microsite_id);
                    for(let content_id of contents_id){
                        formData.append('contents_id[]', content_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

//create

export function create(){
    let today = moment().format('yyyy-MM-DD hh:mm');
    $('#new_content').find('[name="published_at"]').val(today);
    $('#new_content').find('[name="date_start"]').val(today);

    let type = $('#new_content').find('[name="type"]');

    type.on('change', function(){
        show_hide_form_select_options($(this).val());
    });

    $('#new_menu').find('[name="layout"]').on('change', function(){
        switch ($(this).val()) {
            case 'column':
                $('select[id="select_tags"]').closest('.x-form-input').removeClass('d-none');
                break;
                
            default:
                $('select[id="select_tags"]').closest('.x-form-input').addClass('d-none');
                break;
        }
    });
}

function show_hide_form_select_options(value) {
    switch (value) {
        case 'calendar_entry':
            $('.eventDate').removeClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="layout"]').closest('.x-form-input').addClass('d-none');
            $('[name="highlighted"]').closest('.row').removeClass('d-none');
            break;
        case 'entry':
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="layout"]').closest('.x-form-input').addClass('d-none');
            $('[name="highlighted"]').closest('.row').removeClass('d-none');
            break;

        case 'index':
            $('.eventDate').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').removeClass('d-none');
            $('select[name="layout"]').closest('.x-form-input').removeClass('d-none');
            $('[name="highlighted"]').closest('.row').addClass('d-none');
            break;
    
        default:
            $('.eventDate').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="layout"]').closest('.x-form-input').addClass('d-none');
            $('[name="highlighted"]').closest('.row').addClass('d-none');
            // $('select[id="select_tags"]').closest('.x-form-input').addClass('d-none');
            
            break;
    }
}


// show

export function show(params){

    window.microsite_id = params.microsite_id;
    window.content_id = params.content_id;
    calendars = params.calendars;
    types_visibility = params.types_visibility;
    window.background_colors = params.background_colors;
    section_options = params.section_options;
    block_options = params.block_options;
    window.program_types = params.program_types;

    show_init_content_data();
    show_init_blocks();
    show_init_categories();
    show_init_tags();
    show_init_comments();
    show_init_calendars();
    show_init_media();
    content_versions.index({content_type: params.content_type});

    window._content_languages = params.languages;
    window._content_selected_language = window._locale ?? 'es';
    show_init_language();
    init_copy_buttons();

}

// content data

function show_init_content_data(){
 
    $('#edit_content').on('submit', function(){
        let select = $(this).find('select[name="type"]')[0];
        check_type_value(select);
    });

    $('#edit_content input[name="comments_enabled"]').on('click', function() {
        $(this).val($(this).prop('checked') ? 1 : 0);
        if ($(this).prop('checked')) {
            $('#edit_content input[name="comments_blocked"]').prop('disabled', false);
        } else {
            $('#edit_content input[name="comments_blocked"]').prop('disabled', true);
        }
    });

    $('#edit_content input[name="comments_blocked"]').on('click', function() {
        $(this).val($(this).prop('checked') ? 1 : 0);
    });

    $('#main_image').on('change', function(){
        let row = $(this).closest('.row');
        let col_img = row.find('.main_image');
        col_img.removeClass('d-flex').addClass('d-none');
    });

    let type = $('#edit_content').find('[name="type"]');
    type.on('change', function(){
        show_hide_form_select_options($(this).val());
    });
    show_hide_form_select_options(type.val())
    check_type_value(document.getElementById('type'));
}



function check_type_value(element) {
    let calendars_include = $('#calendars_include');
    if (element.value == 'calendar_entry') {
        calendars_include.removeClass('d-none');
        let form_calendar_entry = $('#edit_calendar_entry');
        let date_input = form_calendar_entry.find('input[name="date_start"]');
        if (date_input.val() == '') {
            let today = new Date().toJSON().slice(0, 10);
            date_input.val(today);
        }
    } else {
        calendars_include.addClass('d-none');
    }

}

export function filter_authors(data){

    let results = $.map(data.results, function(obj, index) {
        return { 
            id: obj.id, 
            text: obj.name,
            result: obj.name + '<small class="d-block font-weight-light">' + obj.username + "</small>"
        };
    });

    return {
        results: [{id: 0, text: '&nbsp;'}].concat(results) 
    };

}

// import content
function show_init_import_contents(){
    // datatable import_content
    let table_columns = [
        { width: '60', data: null, orderable: false, searchable: false, render: render_import_contents_actions },
        { width: '20', data: 'visibility', class: 'px-0', orderable: false, searchable: false , render: render_contents_visible},
        { data: 'title', orderable: true, searchable: true },
        { data: 'microsite', orderable: true, searchable: true },
        { width: '100', data: 'status', orderable: true, searchable: true },
    ]

    let table_order = [3, 'asc'];

    if (content_type != 'page' && content_type != 'index') {
        table_columns.push({ width: '100', data: 'published_at', orderable: true, searchable: true, render: datatables.render_date});
        table_order = [5, 'desc'];
        if (content_type == 'calendar_entry') {
            table_columns.push({ width: '100', data: 'date_start', orderable: true, searchable: true, render: datatables.render_datetime});
            table_order = [6, 'desc'];
        }
    }

        
    dt_import_contents = $('#import_contents_table').DataTable({
        ajax: {
            url: $('#import_contents_table').attr('url'),
        },
        columns: table_columns,
        order: table_order,
    });

    dt_import_contents.on('draw', function(e, settings){
        $(settings.nTableWrapper).find('.import_selected').click(import_selected_content);
        $(settings.nTableWrapper).find('.clone_selected').click(show_content_to_clone);
    });
}

function render_import_contents_actions(data, type, row){

    const url_import = ($("#import_contents_table").attr('url_info') ?? '').replace('#', row.id);
    const url_clone = window._routes['microsites.contents.get_content_to_clone'].replace('{microsite}', window.microsite_id).replace('{content}', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <button class="btn btn-primary btn-xs import_selected ajax" url="'+url_import+'">' + window.__('importar') + '</button>' +
        '   <button class="btn btn-secondary btn-xs clone_selected" url_clone="'+url_clone+'" data-closed="#import_contents_modal" data-target="#clone_contents_modal"">' + window.__('clonar') + '</button>' +
        '</div>';

    return actions;

}

function import_selected_content(){
    const url = $(this).attr('url');

    let formData = new FormData();
    
    window.forms.post(url, formData, true, true)
        .then((response) => {
            switch (response.data.message_level) {
                case 'error':
                    window.messages.error(response.data.message);
                    break;
            
                default:
                    window.messages.info(response.data.message);
                    break;
            }
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            index_reload();
            window.blockui.release();
            $('#import_contents_modal').modal('hide');
        });
}

function show_content_to_clone(){
    
    const url = $(this).attr('url_clone');

    axios.get(url)
        .then((response) => {
            if (response.data) {
                let content = response.data.content;
                let modal = $($(this).attr('data-closed'));
                modal.modal('hide');
                let target_modal = $($(this).attr('data-target'));
                target_modal.modal('show');
    
                target_modal.find('[name="title"]').val(content.title);
                target_modal.find('[name="slug"]').val(content.slug);

                let select_type = target_modal.find('[name="type"]').val(content.type);
                select_type.select2({
                    theme: 'bootstrap',
                    width: 'resolve',
                });
                
                show_hide_form_select_options(content.type);
                select_type.on('change', function(){
                    show_hide_form_select_options($(this).val());
                });
                
                let today = moment().format('yyyy-MM-DD HH:mm');
                target_modal.find('[name="published_at"]').val(today);

                if (content.date_start != null) {
                    let date_start = moment(content.date_start).format('yyyy-MM-DD HH:mm');
                    target_modal.find('[name="date_start"]').val(date_start);
                }
                if (content.date_end != null) {
                    let date_end = moment(content.date_end).format('yyyy-MM-DD HH:mm');
                    target_modal.find('[name="date_end"]').val(date_end);
                }

                target_modal.find('[name="summary"]').val(content.summary);
                target_modal.find('[name="highlighted"]').attr('checked', content.highlighted);


                let action = target_modal.find('form').attr('action').replace('#', content.id);
                target_modal.find('form').attr('action', action);
            }
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
        });
}

export function import_list_reload(){
    dt_import_contents.ajax.reload();
}

// categories

function show_init_categories(){

    // datatable categories
    
    dt_categories = $('#categories_table').DataTable({
        ajax: {
            url: $('#categories_table').attr('url'),
        },
        autoWidth: false,
        columns: [
            { width: '140', data: null, orderable: false, searchable: false, class: 'actions', render: render_categories_actions },
            { width: '20', data: 'visibility', class: 'px-0', orderable: false, searchable: false , render: render_contents_visible},
            { data: 'name', orderable: false, searchable: true,  render: render_categories_name},
        ],
        order: false,
    });

    dt_categories.on('draw', function(e, settings){
        $(settings.nTableWrapper).find('.update_selected').click(attach_taxonomy);
        $(settings.nTableWrapper).find('.update_main').click(update_main);
    });

}

function render_categories_actions(data, type, row){

    const main = !row.disabled
        ? '<button '+ (!row.selected ? 'disabled' : '') +' class="btn ' + (row.main ? 'btn-success' : 'btn-default') + ' btn-xs update_main" taxonomy_id="'+row.id+'" main="' + row.main +'" >' + window.__('principal') + '</button>'
        : '<button disabled class="btn btn-default btn-xs" taxonomy_id="'+row.id+'" main="' + row.main +'">' + window.__('principal') + '</button>';

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <button '+ (row.disabled ? 'disabled' : '') +' class="btn ' + (row.selected ? 'btn-success' : 'btn-default') + ' btn-xs update_selected" taxonomy_id="'+row.id+'" active="' + row.selected +'" >' + (row.selected ? window.__('seleccionada') : window.__('seleccionada')) + '</button>' +
        '   ' + main +
        '</div>';

    return actions;
}

function render_categories_name(data, type, row){

    let string = "";
    if(row.level == 0){
        string = row.name;
    } else {
        for (let i=0; i < row.level; i++) { 
            string += "<div class=\"d-inline-block px-3\"></div>";
        }
        string = string + "<div class=\"d-inline-block mr-3\"><i class=\"fas fa-level-up-alt fa-rotate-90\"></i></div>" + row.name;
    }

    return string;
}

export function categories_reload(){

    if(dt_categories != null){
        dt_categories.ajax.reload();
    }
    if(dt_tags != null){
        dt_tags.ajax.reload();
    }

}

function attach_taxonomy(){

    const taxonomy_id = $(this).attr('taxonomy_id');
    const active = $(this).attr('active') == 'true' ? true : false;
    const route = window._routes['microsites.contents.attach_taxonomy'].replace('{microsite}', window.microsite_id);

    let formData = new FormData();
    formData.append('selected', active ? true : false);
    formData.append('taxonomy_id', taxonomy_id);
    formData.append('content_id', window.content_id);
    
    window.forms.post(route, formData);

}

function update_main(){

    const taxonomy_id = $(this).attr('taxonomy_id');
    const main = $(this).attr('main') == '1' ? true : false;
    const route = window._routes['microsites.contents.update_main_category'].replace('{microsite}', window.microsite_id);

    let formData = new FormData();
    formData.append('main', main ? true : false);
    formData.append('taxonomy_id', taxonomy_id);
    formData.append('content_id', window.content_id);
    
    window.forms.post(route, formData);

}

// tags

function show_init_tags(){

    // datatable tags
    
    dt_tags = $('#tags_table').DataTable({
        ajax: {
            url: $('#tags_table').attr('url'),
        },
        autoWidth: false,
        columns: [
            { width: '75', data: null, orderable: false, searchable: false, class: 'actions', render: render_tags_actions },
            { width: '20', data: 'visibility', class: 'px-0', orderable: false, searchable: false , render: render_contents_visible},
            { data: 'name', orderable: false, searchable: true }, // render: render_tags_name},
        ],
        order: false,
    });

    dt_tags.on('draw', function(e, settings){
        $(settings.nTableWrapper).find('.update_selected').click(attach_taxonomy);
    });

    $('#add_tag').on('submit', function() {
        $('#add_tag_modal').modal('hide');
    });

    $('#add_tag_modal').on('show.bs.modal', function(){
        $('#add_tag')[0].reset();
    });

}

function render_tags_actions(data, type, row){
    const actions = 
        '<div class="btn-group" role="group">' +
        '   <button '+ (row.disabled ? 'disabled' : '') +' class="btn ' + (row.selected ? 'btn-success' : 'btn-default') + ' btn-xs update_selected" taxonomy_id="'+row.id+'" active="' + row.selected +'" >' + (row.selected ? window.__('seleccionada') : window.__('seleccionada')) + '</button>' +
        '</div>';

    return actions;
}

// function render_tags_name(data, type, row){

//     let string = "";
//     for (let i=0; i < row.level; i++) { 
//         string += "&nbsp;&nbsp;";
//     }
//     string = string+"&#8627;"+" "+row.name;

//     return string;
// }

// calendars

function show_init_calendars(){

    // datatable calendars
    
    dt_calendars = $('#calendars_table').DataTable({
        ajax: {
            url: $('#calendars_table').attr('url'),
        },
        autoWidth: false,
        columns: [
            { width: '100', data: null, orderable: false, searchable: false, class: 'actions', render: render_calendars_actions },
            { data: 'name', orderable: true, searchable: true},
        ],
        order: false,
    });

    dt_calendars.on('draw', function(e, settings){
        $(settings.nTableWrapper).find('.update_selected').click(attach_calendar);
    });

}

function render_calendars_actions(data, type, row){
    let active = row.contents.length > 0 ? "true" : "false"
    const actions = 
        '<div class="btn-group" role="group">' +
        '   <button '+ (row.disabled ? 'disabled' : '') +' class="btn ' + (row.contents.length > 0 ? 'btn-success' : 'btn-secondary') + ' btn-xs update_selected" calendar_id="'+row.id+'" active="' + active +'" >' + (row.contents.length > 0 ? window.__('seleccionada') : window.__('seleccionada')) + '</button>' +
        '</div>';

    return actions;
}


export function calendars_reload(){

    dt_calendars.ajax.reload();

}

function attach_calendar(){

    const calendar_id = $(this).attr('calendar_id');
    const active = $(this).attr('active') == 'true' ? true : false;
    const route = window._routes['microsites.contents.attach_calendar'].replace('{microsite}', window.microsite_id);

    let formData = new FormData();
    formData.append('selected', active ? true : false);
    formData.append('calendar_id', calendar_id);
    formData.append('content_id', window.content_id);
    
    window.forms.post(route, formData);

}

// blocks

function show_init_blocks(){
    
    blocks.row.init(window.microsite_id, window.content_id);
    blocks.title.init();
    blocks.textarea.init();
    blocks.image.init();
    blocks.video.init();
    blocks.index.init();
    blocks.button.init();
    blocks.form.init();
    blocks.calendar.init();
    blocks.slider.init();
    blocks.external_video.init();
    blocks.slider_images.init();
    blocks.divider.init();
    blocks.program.init();
    blocks.speakers.init();
    blocks.gallery.init();

    $('#add_block_modal:not(.init)').on('show.bs.modal', function (event) {
        
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);
        
        let all_selects = $('#add_block').find('select');

        all_selects.each(function(){
            $(this).find('option:nth-child(1)').prop('selected', true).trigger('change');
        });

        let select = $('#add_block').find('select[name="type"]');
        select.empty().trigger('change');
        if (block.parent().attr('id') != 'content_blocks') {

            for (let option in block_options) {
                var newOption = new Option(block_options[option], option, false, false);
                select.append(newOption).trigger('change');
            }
            select.find('option[value="title"]').prop('selected', true);
            show_hide_blocks_select_options('title');
        } else {
            for (let option in section_options) {
                var newOption = new Option(section_options[option], option, false, false);
                select.append(newOption).trigger('change');
            }
            select.find('option[value="row"]').prop('selected', true);
            show_hide_blocks_select_options('row');
        }

        select.select2({
            dropdownParent: '#add_block_modal',
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
            theme: 'bootstrap',
            width: 'resolve',
        });

        modal.find('[name="block_id"]').val(block.attr('id'));

    }).addClass('init');

    $('#add_block_modal select[name="type"]').on('change', function () {
        
        show_hide_blocks_select_options($(this).val());

    });

    $('#add_block:not(.init)').on("submit", function(e) {
        e.preventDefault();

        let block = $('#' + $(this).find('input[name="block_id"]').val());
        let form_data = new FormData($(this)[0]);
        form_data.append('new_block_id', get_random_id(10));

        // para las nuevas columnas
        form_data.append('new_block_id_0', get_random_id(10));
        form_data.append('new_block_id_1', get_random_id(10));
        form_data.append('new_block_id_2', get_random_id(10));

        let form_id = form_data.get('form_id');
        if (form_id != null) {
            let form_select = $(this).find('select[name="form_id"]');
            form_id = {
                id: form_id,
                text: form_select.text()
            };
            form_data.set('form_id', JSON.stringify(form_id));
        }

        let type =  $(this).find('[name="type"]');
        if (block.parent().attr('id') != 'content_blocks') {
            form_data.set('section', '');
        } else {
            //Estos bloques no se meten dentro de una columna ni fila a primer nivel para formar una seccion
            if (type.val() != 'row' && type.val() != 'slider' && type.val() != 'divider' && type.val() != 'predefined_block' && type.val() != 'program' && type.val() != 'speakers' && type.val() != 'gallery') {
                form_data.set('section', 'true');
            } else {
                form_data.set('section', '');
            }
        }

        switch (type.val()) {
            case 'title':
                var translations = {};
                for(let _language of window._content_languages){
                    translations[_language] = { 'title': '', 'subtitle': ''};
                    translations[_language]['title'] = form_data.get('title');
                    translations[_language]['subtitle'] = form_data.get('subtitle') ?? '';
                }

                form_data.append('translations', JSON.stringify(translations));
                break;

            case 'button':
                var translations = {};
                for(let _language of window._content_languages){
                    translations[_language] = { 'title': '', 'url': '', 'text': ''};
                    translations[_language]['title'] = form_data.get('title') ?? '';
                    translations[_language]['url'] = form_data.get('url') ?? '';
                    translations[_language]['text'] = form_data.get('button_title');
                }

                form_data.append('translations', JSON.stringify(translations));
                break;

            case 'image':
                var translations = {};
                for(let _language of window._content_languages){
                    translations[_language] = { 'title': '', 'url': '', 'alt': ''};
                    translations[_language]['title'] = form_data.get('title');
                    translations[_language]['alt'] = form_data.get('alt') ?? '';
                    translations[_language]['url'] = form_data.get('url') ?? '';
                }

                form_data.append('translations', JSON.stringify(translations));
                break;

            case 'textarea':
                
                var value = tinymce.get("textarea_create").getContent();
                form_data.set('textarea', value);

                var translations = {};
                for(let _language of window._content_languages){
                    translations[_language] = { 'value': ''};
                    translations[_language]['value'] = value ?? '';
                }

                form_data.append('translations', JSON.stringify(translations));
                break;

            case 'predefined_block':
                form_data.append('new_block_id_3', get_random_id(10));
                form_data.append('new_block_id_4', get_random_id(10));
                form_data.append('new_block_id_5', get_random_id(10));

                //textarea
                var value = tinymce.get("textarea_create").getContent();
                form_data.set('textarea', value);

                var translations = {};
                translations = { 'title': {}, 'textarea': {}, 'button': {}, 'image': {}}
                for(let _language of window._content_languages){


                    //bloque titulo
                    translations['title'][_language] = { 'title': '', 'subtitle': ''};
                    translations['title'][_language]['title'] = form_data.get('title') ?? '';
                    translations['title'][_language]['subtitle'] = form_data.get('subtitle') ?? '';

                    //bloque textarea
                    translations['textarea'][_language] = { 'value': '',};
                    translations['textarea'][_language]['value'] = value ?? '';

                    //bloque button
                    translations['button'][_language] = { 'title': '', 'text': '' , 'url': ''};
                    translations['button'][_language]['title'] = '';
                    translations['button'][_language]['text'] = form_data.get('button_title') ?? '';
                    translations['button'][_language]['url'] = '';

                    //bloque image
                    translations['image'][_language] = { 'title': '', 'alt': '', 'url': ''};
                    translations['image'][_language]['title'] = '';
                    translations['image'][_language]['alt'] = '';
                    translations['image'][_language]['url'] = '';
                }

                form_data.append('translations', JSON.stringify(translations));

                break;
        
            default:
                break;
        }

        $('#add_block_modal').modal('hide');
        
        get_block_view(form_data);
        $(this)[0].reset();
    }).addClass('init');

    $('#save_block .save_button:not(.init)').on('click', function () {
        
        let json = get_json_content();
        save_content_blocks(json);

    }).addClass('init');

    $('#save_block .preview:not(.init)').on('click', function () {
        
        let json = get_json_content();
        preview_content_blocks(json);

    }).addClass('init');

    let textarea_edit = $('#edit_textarea').find('textarea[name="textarea"]');
    let textarea_add = $('#add_block').find('textarea[name="textarea"]');

    init_tiny(textarea_edit);
    init_tiny(textarea_add);

    init_blocks();

}

function get_block_view(form_data) {

    let url = window._routes['microsites.contents.block'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    window.forms.post(url, form_data, true, true)
        .then((response) => {

            if (response.data.message) {
                switch (response.data.message_level) {
                    case 'error':
                        window.messages.error(response.data.message);
                        break;

                    case 'warning':
                        window.messages.warning(response.data.message);
                        break;
                
                    default:
                        window.messages.info(response.data.message);
                        break;
                }
                
            } else {

                $('#' + response.data.after_id).after(response.data.block);

                init_blocks();
                
                switch (form_data.get('type')) {
                    case 'title':

                        blocks.title.init_edit_button(response.data.sub_block_id ?? response.data.row_id);
                        break;

                    case 'form':
                        let block_id = typeof response.data.sub_block_id !== 'undefined'
                                ? response.data.sub_block_id
                                : response.data.row_id;

                        blocks.form.init_form_block(block_id);
                        break;

                    case 'textarea':
                        
                        blocks.textarea.init_textarea_block(response.data.row_id);
                        break;

                    case 'index':
                        let index_block = typeof response.data.sub_block_id !== 'undefined'
                                ? $('#'+response.data.sub_block_id)
                                : $('#'+response.data.row_id);

                        blocks.index.init_table_entries(index_block);
                        break;

                    case 'calendar':
                        let block = typeof response.data.sub_block_id !== 'undefined'
                                ? $('#'+response.data.sub_block_id)
                                : $('#'+response.data.row_id);

                        let select = $('#add_block .x-form-input select[name="calendar_id"]');
                        blocks.calendar.add_data_elements(select, block);
                        break;

                    case 'slider':
                        
                        blocks.slider.init_slider_block(response.data.slider_id);
                        create_visible_button_blocks($('#'+response.data.slider_id));
                        break;

                    case 'slider_images':
                        
                        blocks.slider_images.init_slider_images_block(response.data.row_id);
                        // create_visible_button_blocks($('#'+response.data.row_id));
                        break;

                    case 'predefined_block':
                        
                        let ids = response.data.ids;
                        ids.forEach(element => {
                            let block = $('#' + element);
                            create_visible_button_blocks(block);
                        });

                        break;

                    case 'gallery':
                        
                        blocks.gallery.init_gallery_block(response.data.row_id);
                        create_visible_button_blocks($('#'+response.data.row_id));
                        break;
                
                    default:
                        break;
                }
                create_visible_button_blocks($('#'+response.data.row_id));
            }
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
        });
}

function init_blocks(row_id){

    let _block = typeof row_id == 'undefined'
                    ? $('#content_blocks .block:not(.init)')
                    : $('#content_blocks #' + row_id + ' .block:not(.init)')

    _block.each(function(){

        $(this).find('.btn.up:not(.init)').click(function(){
            
            let block = $(this).closest('.block');
            let prev_block = block.prev('.block:not([data-type="start"])');
            prev_block.before(block);
    
            reorder_blocks();
        }).addClass('init');
    
        $(this).find('.btn.down:not(.init)').click(function(){

            let block = $(this).closest('.block');
            let next_block = block.next('.block:not([data-type="start"])');
            next_block.after(block);
            
            reorder_blocks();
        }).addClass('init');

        $(this).find('.btn.move_block:not(.init)').each(function(){
        
            $(this)[0].addEventListener("dragstart", (event) => {
                event.stopPropagation();
    
                let container = $(event.target).closest('.drag-container');
                container.addClass('dragging');
    
                let block = $(event.target).closest('.block');
    
                event.dataTransfer.effectAllowed = 'move';
                event.dataTransfer.setData('text/plain', block.attr('id'));
    
                var dragImage = document.createElement('div');
                dragImage.id = 'drag-handler';
                dragImage.innerHTML = '<i class="fa-solid fa-plane"></i>';
                dragImage.setAttribute('style', 'position: absolute; left: 0px; top: 0px; width: 30px; height: 30px; z-index: -1');
                document.body.appendChild(dragImage);
                event.dataTransfer.setDragImage(dragImage, 20, 20);
    
            });
        
            $(this)[0].addEventListener("dragend", (event) => {
            
                $('#drag-handler').remove();
                
                let block = $(event.target).closest('.drag-container');
                block.removeClass('dragging');
        
            });
    
        }).addClass('init');

        $(this).find('.btn.btn-drop-block:not(.init)').each(function(){

            $(this)[0].addEventListener("dragover", (event) => {
                event.preventDefault();
            });
    
            $(this)[0].addEventListener("dragenter", (event) => {
                event.preventDefault();
                if(event.dataTransfer.getData('text/plain') != $(event.target).closest('.block').attr('id')){
                    $(event.target).addClass('drop');
                }
            });
    
            $(this)[0].addEventListener("dragleave", (event) => {
                event.preventDefault();
                $(event.target).removeClass('drop');
            });
        
            $(this)[0].addEventListener("drop", (event) => {
                event.stopPropagation();
    
                let block = $('#' + event.dataTransfer.getData('text/plain'));
                let move_after = $(event.target).closest('.block');
    
                if(
                    block.length > 0 
                    && move_after.length > 0
                    && block.attr('id') != move_after.attr('id')
                ){
                    move_after.after(block.detach());
                    reorder_blocks();
                }
                
            });

        }).addClass('init');

        
        blocks.row.init_columns($(this).attr('id'));

        switch ($(this).attr('data-type')) {
            case 'slider':
                blocks.slider.init_slides($(this).attr('id'));
                break;
            case 'slider_images':
                blocks.slider_images.init_slides($(this).attr('id'));
                break;
            case 'gallery':
                blocks.gallery.init_slides($(this).attr('id'));
                break;
            case 'index':
                blocks.index.init();
                break;
        
            default:
                break;
        }

        // inicializar bloque
        $(this).addClass('init');
    });
    
    show_start_block();
    show_block_order();

}

export function show_start_block(){
    
    if($('#content_blocks .block').length > 1){
        $('#content_blocks #start_block').hide();
        $('#content_blocks #save_block')
            .removeClass('d-none')
            .show();
    } else {
        $('#content_blocks #start_block')
            .removeClass('d-none')
            .show();
            $('#content_blocks #save_block').hide();
    }

    $('#content_blocks .column').each(function(){
        blocks.row.show_start_block($(this).attr('id'));
    });

    $('#content_blocks .block[data-type="row"]').each(function(){
        blocks.row.show_start_column_block($(this).attr('id'));
    });

}

export function show_block_order(container_id = 'content_blocks'){

    let _blocks = $('#' + container_id).hasClass('column')
        ? $('#'+ container_id +' > .card >.blocks > .block:not([data-type="start"])')
        : $('#'+ container_id +' > .block:not([data-type="start"])');

    if(_blocks.length > 1){

        for(let i=0; i<_blocks.length; i++){

            $('#order-' + $(_blocks[i]).attr('id') + ' .up').show().prop('disabled', i == 0);
            $('#order-' + $(_blocks[i]).attr('id') + ' .down').show().prop('disabled', i == _blocks.length - 1);
            $('#order-' + $(_blocks[i]).attr('id') + ' .move_block').show();

            if($(_blocks[i]).data('type') == 'row'){
                blocks.row.show_block_order($(_blocks[i]).attr('id'));
            }

        }

    } else {

        for(let i=0; i<_blocks.length; i++){
            $('#order-' + $(_blocks[i]).attr('id') + ' .up').hide();
            $('#order-' + $(_blocks[i]).attr('id') + ' .down').hide();
            $('#order-' + $(_blocks[i]).attr('id') + ' .move_block').hide();

            if($(_blocks[i]).data('type') == 'row'){
                blocks.row.show_block_order($(_blocks[i]).attr('id'));
            }
        }

    }

}

function reorder_blocks(){
    $('#content_blocks blocks').each(function(index){
        $(this).attr('data-index', index);
    });

    show_block_order();
}

function get_json_content() {

    let _blocks = $('#content_blocks > .block:not([data-type="start"])')

        let content = [];

        _blocks.each(function(){
            
            let _block = $(this);
            
            content.push(get_block(_block));
        });

        return content;
}

function get_block(_block) {

    let block = {
        id: _block.attr('id'),
        type: _block.attr('data-type'),
        class: _block.attr('data-class'),
        visible: _block.attr('data-visible'),
        hide_mobile: _block.attr('data-mobile-hidden'),
        hide_tablet: _block.attr('data-tablet-hidden'),
        hide_desktop: _block.attr('data-desktop-hidden'),
    };
    
    //switch
    switch (block.type) {
        case 'row':

            let background = {};
            try {
                background = JSON.parse(_block.attr('data-background'));
                if(typeof background != 'object'){
                    background = {};
                }
            } catch (error) {
                background = {};
            }

            translations = {};
            try {
                translations = JSON.parse(_block.attr('data-translations'));
                if(typeof translations != 'object'){
                    translations = {};
                }
            } catch (error) {
                translations = {};
            }


            // block.background = _block.attr('data-background');
            block.background = background;
            block.translations = translations;
            block.full_width = _block.attr('data-full-width');
            block.min_height_xs = _block.attr('data-min-height-xs');
            block.min_height_md = _block.attr('data-min-height-md');
            block.min_height_xl = _block.attr('data-min-height-xl');
            block.columns = get_columns_block(_block);
            break;

        case 'title':
            
            block.title = _block.attr('data-title');
            block.width = _block.attr('data-width');
            block.subtitle = _block.attr('data-subtitle');
            block.align = _block.attr('data-align');

            translations = {};
            try {
                translations = JSON.parse(_block.attr('data-translations'));
                if(typeof translations != 'object'){
                    translations = {};
                }
            } catch (error) {
                translations = {};
            }

            block.translations = translations;
            break;

        case 'textarea':

            translations = {};
            try {
                translations = JSON.parse(_block.attr('data-translations'));
                if(typeof translations != 'object'){
                    translations = {};
                }
            } catch (error) {
                translations = {};
            }

            block.value = _block.attr('data-value').trim();
            block.translations = translations;
            break;

        case 'image':
            
            translations = {};
            try {
                translations = JSON.parse(_block.attr('data-translations'));
                if(typeof translations != 'object'){
                    translations = {};
                }
            } catch (error) {
                translations = {};
            }

            block.media_id = _block.attr('data-media-id');
            block.name = _block.attr('data-name');
            block.src = _block.attr('data-src');
            block.thumb_src = _block.attr('data-thumb-src');
            block.width = _block.attr('data-width');
            // block.height = _block.attr('data-height');
            block.align = _block.attr('data-align');
            block.alt = _block.attr('data-alt');
            block.title = _block.attr('data-title');
            block.url = _block.attr('data-url');
            block.link_type = _block.attr('data-link-type');
            block.style = _block.attr('data-style');
            block.blank = _block.attr('data-blank');
            block.nofollow = _block.attr('data-nofollow');
            block.translations = translations;
            break;
    
        case 'video':
            
            block.name = _block.attr('data-name');
            block.src = _block.attr('data-src');
            block.width = _block.attr('data-width');
            block.height = _block.attr('data-height');
            block.align = _block.attr('data-align');
            block.autoplay = _block.attr('data-autoplay');
            block.controls = _block.attr('data-controls');
            block.media_id = _block.attr('data-media-id');
            block.preview_src = _block.attr('data-preview-src');
            block.preview_name = _block.attr('data-preview-name');
            block.preview_media_id = _block.attr('data-preview-media-id');
            break;

        case 'index':

            block.index_type = _block.attr('data-index-type');
            block.view = _block.attr('data-view');
            block.title = _block.attr('data-title');
            block.pagination = _block.attr('data-pagination');
            block.count = _block.attr('data-count');
            block.link = _block.attr('data-link');
            block.elements = JSON.parse(_block.attr('data-elements'));
            break;

        case 'button':
            translations = {};
            try {
                translations = JSON.parse(_block.attr('data-translations'));
                if(typeof translations != 'object'){
                    translations = {};
                }
            } catch (error) {
                translations = {};
            }

            block.text = _block.attr('data-text');
            block.title = _block.attr('data-title');
            block.url = _block.attr('data-url');
            block.link_type = _block.attr('data-link-type');
            block.align = _block.attr('data-align');
            block.style = _block.attr('data-style');
            block.blank = _block.attr('data-blank');
            block.nofollow = _block.attr('data-nofollow');
            block.translations = translations;
            break;

        case 'form':

            block.form = _block.attr('data-form');
            break;

        case 'calendar':

            block.calendars = JSON.parse(_block.attr('data-elements'));
            break;

        case 'slider':
            
            block.full_width = _block.attr('data-full-width');
            block.autoplay = _block.attr('data-autoplay');
            block.interval = _block.attr('data-interval');
            block.show_index = _block.attr('data-show-index');
            block.slides = get_slides_block(_block);
            break;

        case 'external_video':
            
            block.external_video_type = _block.attr('data-external-video-type');
            block.src = _block.attr('data-src');
            block.width = _block.attr('data-width');
            block.height = _block.attr('data-height');
            block.align = _block.attr('data-align');
            block.autoplay = _block.attr('data-autoplay');
            block.controls = _block.attr('data-controls');
            block.preview_src = _block.attr('data-preview-src');
            block.preview_name = _block.attr('data-preview-name');
            block.preview_media_id = _block.attr('data-preview-media-id');
            break;

        case 'slider_images':
            
            block.full_width = _block.attr('data-full-width');
            block.autoplay = _block.attr('data-autoplay');
            block.interval = _block.attr('data-interval');
            block.xs_images = _block.attr('data-xs-images');
            block.md_images = _block.attr('data-md-images');
            block.xl_images = _block.attr('data-xl-images');
            block.slides = get_slides_images_block(_block);
            break;

        case 'divider':
            
            background = {};
            try {
                background = JSON.parse(_block.attr('data-background'));
                if(typeof background != 'object'){
                    background = {};
                }
            } catch (error) {
                background = {};
            }

            translations = {};
            try {
                translations = JSON.parse(_block.attr('data-translations'));
                if(typeof translations != 'object'){
                    translations = {};
                }
            } catch (error) {
                translations = {};
            }

            // block.background = _block.attr('data-background');
            block.background = background;
            block.translations = translations;
            block.ignore_ratio = _block.attr('data-ignore-ratio');
            block.xs_height = _block.attr('data-xs-height');
            block.md_height = _block.attr('data-md-height');
            block.xl_height = _block.attr('data-xl-height');
        break;

        case 'program':

            block.data_program_type = _block.attr('data-program-type');
            block.data_days =  JSON.parse(_block.attr('data-days'));
            block.data_rooms =  JSON.parse(_block.attr('data-rooms'));
            block.data_tipos =  JSON.parse(_block.attr('data-tipos'));
            block.data_areas =  JSON.parse(_block.attr('data-areas'));
            
            block.data_show_horas = _block.attr('data-show-horas');
            block.data_show_area = _block.attr('data-show-area');
            block.data_show_type = _block.attr('data-show-type');

            block.data_show_sesion = _block.attr('data-show-sesion');
            block.data_show_sesion_title = _block.attr('data-show-sesion-title');
            block.data_show_sesion_description = _block.attr('data-show-sesion-description');
            block.data_show_sesion_area = _block.attr('data-show-sesion-area');
            block.data_show_sesion_type = _block.attr('data-show-sesion-type');
            block.data_show_sesion_link = _block.attr('data-show-sesion-link');
            block.data_show_sesion_medias = _block.attr('data-show-sesion-medias');
            block.data_show_moderators = _block.attr('data-show-moderators');

            block.data_show_details_info = _block.attr('data-show-details-info');
            block.data_show_details_horas = _block.attr('data-show-details-horas');
            block.data_show_details_title = _block.attr('data-show-details-title');
            block.data_show_details_description = _block.attr('data-show-details-description');
            block.data_show_details_link = _block.attr('data-show-details-link');
            block.data_show_details_medias = _block.attr('data-show-details-medias');
            block.data_show_authors = _block.attr('data-show-authors');

            block.data_show_users_photo = _block.attr('data-show-users-photo');
            block.data_show_users_position = _block.attr('data-show-users-position');
            block.data_show_users_work_place = _block.attr('data-show-users-work-place');
            block.data_show_users_title = _block.attr('data-show-users-title');
        break;

        case 'speakers':

            block.data_photo = _block.attr('data-photo');
            block.data_title = _block.attr('data-title');
            block.data_position = _block.attr('data-position');
            block.data_work_place = _block.attr('data-work-place');
            block.data_session_types =  JSON.parse(_block.attr('data-session-types'));
            block.data_moderators = _block.attr('data-moderators');
            block.data_speakers = _block.attr('data-speakers');
            block.data_communicators = _block.attr('data-communicators');
            block.data_show_details = _block.attr('data-show-details');
            block.data_show_details_photo = _block.attr('data-show-details-photo');
            block.data_show_details_title = _block.attr('data-show-details-title');
            block.data_show_details_position = _block.attr('data-show-details-position');
            block.data_show_details_work_place = _block.attr('data-show-details-work-place');
            block.data_show_details_curriculum = _block.attr('data-show-details-curriculum');
            block.data_show_details_description = _block.attr('data-show-details-description');
            block.data_show_details_sesions = _block.attr('data-show-details-sesions');

        break;

        case 'gallery':
            
            block.xs_images = _block.attr('data-xs-images');
            block.md_images = _block.attr('data-md-images');
            block.xl_images = _block.attr('data-xl-images');
            block.gallery_images = get_gallery_images_block(_block);
            break;
    
        default:
            break;

    }

    return block;
}

function get_columns_block(_block){

    let columns = [];

    _block.find('.columns .column').each(function (index) {
                    
        let _column_div = $(this);
        let column_blocks = _column_div.find('.block:not([data-type="start"])');
        
        let background = {};
        try {
            background = JSON.parse(_column_div.attr('data-background'));
            if(typeof background != 'object'){
                background = {};
            }
        } catch (error) {
            background = {};
        }

        let column = {
            id: _column_div.attr('id'),
            type: 'column',
            class: _column_div.attr('data-class'),
            visible: _column_div.attr('data-visible'),
            width: {
                xs: _column_div.attr('data-xs-width'),
                md: _column_div.attr('data-md-width'),
                xl: _column_div.attr('data-xl-width')
            },
            order: {
                xs: _column_div.attr('data-xs-order'),
                md: _column_div.attr('data-md-order'),
                xl: index + 1
            },
            blocks: [],
            // background : _column_div.attr('data-background')
            background : background,
        };
    
        column_blocks.each(function() {
            let _block_column = $(this);
            column.blocks.push(get_block(_block_column));
        });

        columns.push(column);

    });

    return columns;
}

function get_slides_block(_block){

    let slides = [];

    _block.find('.slides .slide').each(function () {
                    
        let _slide_div = $(this);

        let background = {};
        try {
            background = JSON.parse(_slide_div.attr('data-background'));
            if(typeof background != 'object'){
                background = {};
            }
        } catch (error) {
            background = {};
        }

        let translations = {};
        try {
            translations = JSON.parse(_slide_div.attr('data-translations'));
            if(typeof translations != 'object'){
                translations = {};
            }
        } catch (error) {
            translations = {};
        }

        
        
        let slide = {
            id: _slide_div.attr('id'),
            type: 'slide',
            class: _slide_div.attr('data-class'),
            // background: _slide_div.attr('data-background'),
            background: background,
            title: _slide_div.attr('data-title'),
            subtitle: _slide_div.attr('data-subtitle'),
            text: _slide_div.attr('data-text'),
            call_to_action: _slide_div.attr('data-call-to-action'),
            url: _slide_div.attr('data-url'),
            link_type: _slide_div.attr('data-link-type'),
            visible: _slide_div.attr('data-visible'),
            blank: _slide_div.attr('data-blank'),
            nofollow: _slide_div.attr('data-nofollow'),
            translations: translations,
        };

        slides.push(slide);
    });

    return slides;
}
function get_slides_images_block(_block){

    let slides = [];

    _block.find('.slides_images .slide_images').each(function () {
        let _slide_div = $(this);

        translations = {};
        try {
            translations = JSON.parse(_slide_div.attr('data-translations'));
            if(typeof translations != 'object'){
                translations = {};
            }
        } catch (error) {
            translations = {};
        }
        
        let slide = {
            id: _slide_div.attr('id'),
            type: 'slide_images',
            class: _slide_div.attr('data-class'),
            alt: _slide_div.attr('data-alt'),
            url: _slide_div.attr('data-url'),
            link_type: _slide_div.attr('data-link-type'),
            img_url: _slide_div.attr('data-img-url'),
            img_name: _slide_div.attr('data-img-name'),
            media_id: _slide_div.attr('data-media-id'),
            visible: _slide_div.attr('data-visible'),
            blank: _slide_div.attr('data-blank'),
            nofollow: _slide_div.attr('data-nofollow'),
            translations: translations
        };

        slides.push(slide);
    });

    return slides;
}

function get_gallery_images_block(_block){

    let gallery_images = [];

    _block.find('.gallery .slide_gallery').each(function () {
                    
        let _image_div = $(this);
        
        let image = {
            id: _image_div.attr('id'),
            type: 'slide_gallery',
            class: _image_div.attr('data-class'),
            alt: _image_div.attr('data-alt'),
            img_footer: _image_div.attr('data-img-footer'),
            img_url: _image_div.attr('data-img-url'),
            img_name: _image_div.attr('data-img-name'),
            media_id: _image_div.attr('data-media-id'),
            visible: _image_div.attr('data-visible'),
        };

        gallery_images.push(image);
    });

    return gallery_images;
}

function save_content_blocks(json) {

    let url = window._routes['microsites.contents.block.store'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    let form_data = new FormData();
    form_data.append('content', JSON.stringify(json));

    window.forms.post(url, form_data, true, true)
        .then((response) => {
            window.messages.info(response.data.message);
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
            content_versions.index_force_reload();
        });

}

function preview_content_blocks(blocks){
    
    let content = JSON.parse($('#preview input[name="content"]').val());
    content.blocks = blocks;

    var f = document.getElementById('preview');
    f.json.value = JSON.stringify(content);
    window.open('', 'semfyc_cms_content_preview');
    f.submit();

}

function show_hide_blocks_select_options(value) {
    switch (value) {

        case 'row':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').removeClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').addClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'title':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').removeClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'textarea':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').addClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').removeClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            tinymce.get('textarea_create').focus();
            break;

        case 'image':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').addClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').removeClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'video':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').addClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').removeClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'index':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').addClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').removeClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'button':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').addClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').removeClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'form':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').addClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').removeClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            break;
            
        case 'calendar':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').addClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').removeClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'external_video':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').addClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').removeClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'divider':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').addClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').removeClass('d-none');
            break;

        case 'predefined_block':

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').removeClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').removeClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').removeClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').removeClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            break;
    
        default:

            $('#add_block').find('select[name="columns"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="title"]').closest('.row').addClass('d-none');
            $('#add_block').find('textarea[name="textarea"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="image"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('input[name="video"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="content_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="button_title"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="form_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="calendar_id"]').closest('.x-form-input').addClass('d-none');
            $('#add_block').find('select[name="external_video_type"]').closest('.row').addClass('d-none');
            $('#add_block').find('input[name="divider_img"]').closest('.x-form-input').addClass('d-none');
            break;
            
    }
}

export function delete_media(media_id) {
    let url = window._routes['microsites.contents.media.delete'].replace('{microsite}', microsite_id).replace('{content}', window.content_id);

    let form_data = new FormData();
    form_data.append('media_id', media_id);
    window.forms.post(url, form_data, true, true)
        .then((response) => {
            if (response.data != null) {
                let form_input = $('button.delete_media').closest('.row');
                let image = form_input.find('input[type="file"]');
                let label = image.next('label');
                label.text('');
            }
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
        });
}

export function create_visible_button_blocks(block){

    let visible = block.attr('data-visible');
    let button = visibility_button(visible, window.__(types_visibility[visible]));

    if(button != ''){
        let card_header = block.find('> .card > .card-header');
        card_header.append(button);
    }

}

export function change_visible_button_blocks(block){

    let visible = block.attr('data-visible');
    block.find('> .card > .card-header .visibility').remove();
    let button = visibility_button(visible, window.__(types_visibility[visible]));
    
    if(button != ''){
        let card_header = block.find('> .card > .card-header');
        card_header.append(button);
    }

}

export function update_content(content){
    if(typeof content.main_image != 'undefined'){
        if(content.main_image == ''){

            $('#edit_content #main_image').val(null);
            $('#edit_content label.custom-file-label[for="main_image"]').text('');

            $('#edit_content .main_image')
                .html('')
                .removeClass('d-flex')
                .addClass('d-none');

        } else {

            $('#edit_content .main_image')
                .html('<img class="border rounded p-2" src="' + content.main_image + '"/>')
                .removeClass('d-none')
                .addClass('d-flex');

        }
    }
}

function visibility_button(visible, text){

    switch (visible) {
        case 'hidden':
            return '<button class="btn btn-default btn-xs btn-visibility disabled visibility" title="' + text + '"><i class="fa-solid fa-eye-slash"></i></button>';

        case 'visible':
            return '<button class="btn btn-primary btn-xs btn-visibility disabled visibility" title="' + text + '"><i class="fa-solid fa-eye"></i></button>';

        case 'only_guest':
            return '<button class="btn btn-secondary btn-xs btn-visibility disabled visibility" title="' + text + '"><i class="fa-solid fa-user-secret"></i></button>';

        case 'only_users':
            return '<button class="btn btn-info btn-xs btn-visibility disabled visibility" title="' + text + '"><i class="fa-solid fa-user"></i></button>';

        case 'only_health':
            return '<button class="btn btn-success btn-xs btn-visibility disabled visibility" title="' + text + '"><i class="fa-solid fa-user-doctor"></i></button>';
            
    }

    return '';

}

function init_tiny(textarea){
    const url = window._routes['microsites.contents.post_image_tiny'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    let options = {
        menubar: false,
        statusbar: false,
        toolbar: 'undo redo | bold italic | fontsizeselect forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist image link | removeformat code | table tabledelete',
        table_toolbar: 'tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
        fontsize_formats: '0.8rem 1rem 1.2rem 1.4rem',
        setup: function(editor) {
            editor.on('PreInit', function() {
                editor.getBody().style.fontSize = '1rem';
            });
          },
        paste_as_text: true,
        autoresize_bottom_margin: 30,
        relative_urls: false,
        remove_script_host: false,
        convert_urls: true,
        apply_source_formatting : false,
        verify_html : false,
        file_picker_types: 'image',
        file_picker_callback: function (cb, value, meta) {

            var input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
        
            input.onchange = function(){
                
                var file = this.files[0];
                var reader = new FileReader();

                reader.onload = function(){

                    var id = 'blobid' + (new Date()).getTime();
                    var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                    var base64 = reader.result.split(',')[1];
                    var blobInfo = blobCache.create(id, file, base64);
                    blobCache.add(blobInfo);
        
                    /* call the callback and populate the Title field with the file name */
                    cb(blobInfo.blobUri(), { title: file.name });

                };

                reader.readAsDataURL(file);

            };
        
            input.click();
            
        },
        images_upload_handler: function(blobInfo, success, failure){

            let form_data = {
                filename: blobInfo.blob().name,
                type: blobInfo.blob().type,
                base64: blobInfo.base64(),
            };

            window.forms.post(url, form_data, true, true)
                .then((response) => {
                    success(response.data.location);
                })
                .catch((error) => {
                    console.log('ERROR', error);
                    failure(window.__('Error subiendo imagen tinymce'));
                })
                .finally(() => {
                    window.blockui.release();
                });

        },
    };

    window.forms.init_tinymce(textarea, options);
}

// utils

function random_id(length = 6) {
    return Math.random().toString(36).substring(2, length+2);
};

function check_id(id, existing = []) {
    let match = existing.find(function(item) {
        return item === id;
    });
    return match ? false : true;
};

export function get_random_id(length) {

    let existing = [];
    let allSelectorsWithId = document.querySelectorAll('[id]');
    allSelectorsWithId.forEach((element) => {
        existing.push(element.id);
    });

    const limit = 100;
    let attempts = 0;
    let id = false;
    while(!id && attempts < limit) {
        id = random_id(length);
        if(!check_id(id, existing)) {
            id = false;
            attempts++;
        }
    }
    
    return id;

}

// Copy buttons
function init_copy_buttons(){
    $('.copy-block:not(.copy-block-init)').each(function(){
        $(this).click(function(){
            let url = window._routes['microsites.contents.block.sign'].replace('{microsite}', microsite_id).replace('{content}', window.content_id);

            let modal = $(this).closest('.modal');
            let block_type = $(this).attr('block-type');
            let block_id;
            switch (block_type) {
                case 'column':
                    block_id = modal.find('input[name="column_id"]').val();
                    break;
            
                default:
                    block_id = modal.find('input[name="block_id"]').val();
                    break;
            }

            let content = $('#'+block_id).get(0);
            let form_data = new FormData();
            form_data.append('block', JSON.stringify(content.outerHTML));

            window.forms.post(url, form_data, true, true)
            .then((response) => {

                if (response.data) {

                    let json = {
                        type: block_type,
                        block: content.outerHTML,
                        sign: response.data.sign
                    }

                    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                        navigator.clipboard.writeText(JSON.stringify(json))
                        .then(() => {
                            window.messages.info(__('Bloque copiado al portapapeles'));
                        })
                        .catch(err => {
                            window.messages.error(__('Error al copiar al portapapeles:', err));
                      });
                    } else {
                        console.log("El bloque no puede ser copiado");
                    }
                }
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
            });

        }).addClass('copy-block-init');
    });

    $('#paste_block_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let first_modal = $(button).closest('.modal');
        let previous_block;
        let block_type = button.attr("block-type");
        switch (block_type) {
            case 'column':
                previous_block = $(first_modal).find('input[name="prev_column_id"]').val();
                break;
        
            default:
                previous_block = $(first_modal).find('input[name="block_id"]').val();
                break;
        }
        let modal = $(this);

        modal.find('[name="block_id"]').val(previous_block);
        modal.find('[name="block_content"]').val('');

        first_modal.modal('hide');
    });

    $('#paste_block').on('submit', function (e) {
        e.preventDefault();
        let url = window._routes['microsites.contents.block.sign.verify'].replace('{microsite}', microsite_id).replace('{content}', window.content_id);

        let form = $(this);
        let modal = form.closest('.modal');
        let previous_block_id = $(form).find('input[name="block_id"]').val();
        let json = $(form).find('[name="block_content"]').val();

        let data = JSON.parse(json);
        let form_data = new FormData();
        form_data.append('previous_block', previous_block_id);
        form_data.append('block', JSON.stringify(data.block));
        form_data.append('sign', data.sign);

        window.forms.post(url, form_data, true, true)
            .then((response) => {
                let previous_block = $('#' +previous_block_id+ ':not()');

                block_options['start'] = 'Start Block';
                section_options['start'] = 'Start Block';
                let blocks_includes = Object.keys(block_options);
                let section_includes = Object.keys(section_options);
                if (response.data && ((blocks_includes.includes(previous_block.attr('data-type')) && blocks_includes.includes(data.type)) || (previous_block.attr('data-type') == 'column' && data.type == 'column') || (section_includes.includes(previous_block.attr('data-type')) && section_includes.includes(data.type)))) {
                    let new_block = JSON.stringify(response.data.block);

                    new_block = replace_blocks_ids(new_block);
                    new_block = new_block.replaceAll('init','');
                    previous_block.after(JSON.parse(new_block));
                    if (data.type == 'column') {
                        blocks.row.init_columns(previous_block.closest('.block').attr('id'));
                    } else {
                        init_blocks();
                    }
                    window.messages.info(__('Bloque pegado correctamente'));
                } else {
                    window.messages.error(__('No se puede pegar el bloque'));
                }
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
                modal.modal('hide');
            });
    });

    function replace_blocks_ids(block){
        // let start_block_pattern = /id=\\"start_block_\S*\\"/gm;
        let start_block_pattern = /start_block_\w*/gm;
        let order_pattern = /order-\w*/gm;
        let block_id_pattern = / id=\\"\w{10}\\"/gm;
        let used_ids = [];
        // sustituir los ids de los start_block_id
        if (start_block_pattern.test(block)) {
            let start_blocks = block.match(start_block_pattern);
            start_blocks.forEach(element => {
                let ids = element.split('_');
                let block_id = ids[2];
                let new_id = get_random_id(10);
                used_ids.push(new_id);
                block = block.replaceAll(block_id, new_id);
            });
        }
        // sustituir los ids de los order_id
        if (order_pattern.test(block)) {
            let order_blocks = block.match(order_pattern);
            order_blocks.forEach(element => {
                let ids = element.split('-');
                let block_id = ids[1];
                let new_id = get_random_id(10);
                used_ids.push(new_id);
                block = block.replaceAll(block_id, new_id);
            });
        }

        // sustituir los ids sueltos restantes
        if (block_id_pattern.test(block)) {
            let blocks = block.match(block_id_pattern);
            blocks.forEach(element => {
                if (!start_block_pattern.test(block) && !order_pattern.test(block)) {
                    let ids = element.match(/\w{10}/);
                    let block_id = ids[0];
                    if (!used_ids.includes(block_id)) {
                        let new_id = get_random_id(10);
                        used_ids.push(new_id);
                        block = block.replaceAll(block_id, new_id);
                    }
                }
            });
        }
        
        return block;
    }
}

// languages

function show_init_language(){

    $('.change_content_language:not(.init_language)').each(function(){
        $(this).click(function(){

            window._content_selected_language = $(this).attr('language');

            $(this).addClass('btn-primary').removeClass('btn-default');
            $('.change_content_language:not([language="' + window._content_selected_language+ '"])').removeClass('btn-primary').addClass('btn-default');

            change_language();

        }).addClass('init_language');
    });

    $('.change_content_language[language="' + window._content_selected_language + '"]').trigger('click');

}

function change_language(){
    
    let title_blocks = $('.block.init[data-type="title"]').each(function(){

        let translations = JSON.parse($(this).attr('data-translations'));
        if(typeof translations[window._content_selected_language] != 'undefined'){

            for(let field of ['title', 'subtitle']){
                if(typeof translations[window._content_selected_language][field] != 'undefined'){
                    $(this).find('.trans.' + field).html(translations[window._content_selected_language][field]);
                }
            }

        }
    });

    let textarea_blocks = $('.block.init[data-type="textarea"]').each(function(){

        let translations = JSON.parse($(this).attr('data-translations'));
        if(typeof translations[window._content_selected_language] != 'undefined'){

            for(let field of ['value']){
                if(typeof translations[window._content_selected_language][field] != 'undefined'){
                    $(this).find('.trans.tiny-container').html(translations[window._content_selected_language][field]);
                }
            }

        }
    });

    let image_blocks = $('.block.init[data-type="image"]').each(function(){

        let translations = JSON.parse($(this).attr('data-translations'));
        if(typeof translations[window._content_selected_language] != 'undefined'){

            $(this).find('.trans.trans_img').attr('src', translations[window._content_selected_language]['thumb_src']);

        }
    });

    let divider_blocks = $('.block.init[data-type="divider"]').each(function(){

        let translations = JSON.parse($(this).attr('data-translations'));
        if(typeof translations[window._content_selected_language] != 'undefined'){

            // $(this).find('.trans.trans_img').attr('src', translations[window._content_selected_language]['thumb_src']);
            $(this).find('.card-body:first').css('background-image', 'url('+ translations[window._content_selected_language]['background']['url'] +')')

        }
    });

    let button_blocks = $('.block.init[data-type="button"]').each(function(){

        let translations = JSON.parse($(this).attr('data-translations'));
        if(typeof translations[window._content_selected_language] != 'undefined'){

            for(let field of ['text']){
                if(typeof translations[window._content_selected_language][field] != 'undefined'){
                    $(this).find('.trans.trans_button').html(translations[window._content_selected_language][field]);
                }
            }

        }
    });

    let slide_blocks = $('.slide.init[data-type="slide"]').each(function(){

        let translations = JSON.parse($(this).attr('data-translations'));
        if(typeof translations[window._content_selected_language] != 'undefined'){

            for(let field of ['title','subtitle','text', 'call_to_action', 'url']){
                if(typeof translations[window._content_selected_language][field] != 'undefined'){
                    $(this).find('.trans.'+ field).html(translations[window._content_selected_language][field]);
                }
            }

            if (typeof translations[window._content_selected_language]['background'] != 'undefined' && typeof translations[window._content_selected_language]['background']['url'] != 'undefined') {
                let card_body = $(this).find('.card-body');
                card_body.children().css({'background-image': 'url('+translations[window._content_selected_language]['background']['url']+')'});
            }
        }
    });

    let slide_images_blocks = $('.slide_images.init[data-type="slide_images"]').each(function(){

        let translations = JSON.parse($(this).attr('data-translations'));
        if(typeof translations[window._content_selected_language] != 'undefined'){

            let card_body = $(this).find('.card-body');
            card_body.find('img').attr('src', translations[window._content_selected_language]['img_url']);

        }
    });

}

// Media

function show_init_media(params){

    dt_media = $('#media_table').DataTable({
        ajax: {
            url: $('#media_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '80', data: null, orderable: false, searchable: false, class: 'actions', render: render_media_actions },
            { data: 'file_name', orderable: true, searchable: true },

        ],
        order: [[2, 'asc']],
    });

    dt_media.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="batch_delete_media"]').click(batch_delete_media);
        $(settings.nTableWrapper).find('.table_batch_actions [action="download_multiple_media"]').click(download_multiple_media);
    });

    dt_media.on('draw', function(e, settings){
        $(settings.nTableWrapper).find('.show_media').click(show_media);
        $(settings.nTableWrapper).find('.download_media').click(download_media);
        $(settings.nTableWrapper).find('.link_media').click(link_media);
    });


    $('#new_media').on('submit', function() {
        $(this).closest('.modal').modal('hide');
    });
}

function render_media_actions(data, type, row){

    const actions = '<div class="btn-group mr-1" role="group">' +
        '   <a class="btn btn-primary btn-xs download_media" media_id="'+row.id+'"><i class="fa-solid fa-download"></i></a>' +
        '</div>'+
        '<div class="btn-group mr-1" role="group">' +
        '   <a class="btn btn-primary btn-xs show_media" media_id="'+row.id+'" media_type="'+row.mime_type+'"><i class="fa-solid fa-display"></i></a>' +
        '</div>'+
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs link_media" media_id="'+row.id+'" media_url="'+row.original_url+'"><i class="fa-solid fa-link"></i></a>' +
        '</div>';

    return actions;

}

function batch_delete_media(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.contents.media.batch_delete'].replace('{microsite}', window.microsite_id);
    
    let medias_id = [];
    $.each(rows_selected, function(index, rowId){
        medias_id.push(rowId);
    });
    
    if(medias_id.length == 0){

        window.messages.error(__('No has seleccionado ningún archivo'));

    } else {

        const title = __('Eliminar archivo');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un archivo.|[2,*] Estás a punto de eliminar :count archivos.', medias_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', window.microsite_id);
                    for(let content_id of medias_id){
                        formData.append('medias_id[]', content_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}

function download_media(){

    const media_id = $(this).attr('media_id');
    let medias_id = [];
    medias_id.push(media_id);

    $('#batch_media_download input[name="medias_id"]').val(JSON.stringify(medias_id));
    $('#batch_media_download')[0].submit();

}

function show_media(){

    const type_media_allowed = ['image/jpeg','image/jpg','image/png','image/webp','video/mp4','application/pdf'];
    const media_id = $(this).attr('media_id');
    const media_type = $(this).attr('media_type');
    const form = $('#media_preview');
    const modal = $('#modal_preview_media');

    $('#media_preview input[name="media_id"]').val(media_id);

    if (type_media_allowed.includes(media_type) == false) {
        form[0].submit();
    } else {
        let url = form[0].action;
        let form_data = new FormData(form[0]);
        
        window.forms.post(url, form_data, true, true)
            .then((response) => {
                if (response.data != null && response.data != '') {
                    let img = modal.find('img');
                    let video = modal.find('video');
                    let embed = modal.find('embed');

                    img.addClass('d-none');
                    video.addClass('d-none');
                    embed.addClass('d-none');

                    switch (media_type) {
                        case 'image/jpeg':
                        case 'image/jpg':
                        case 'image/png':
                        case 'image/webp':
                            img.attr('src', response.data.preview_url);
                            img.removeClass('d-none');
                            break;

                        case 'video/mp4':
                            video.attr('src', response.data.preview_url);
                            video.removeClass('d-none');
                            break;

                        case 'application/pdf':
                            embed.attr('src', response.data.preview_url);
                            embed.removeClass('d-none');
                            modal.modal('handleUpdate');
                            break;
                    
                        default:
                            break;
                    }
                }
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
                modal.modal('show');
            });
    }
}

function link_media(){

    const media_url = $(this).attr('media_url');
    
    if (typeof media_url != 'undefined' && media_url != '' && navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(media_url)
        .then(() => {
            window.messages.info(__('Link copiado al portapapeles'));
        })
        .catch(err => {
            window.messages.error(__('Error al copiar al portapapeles:', err));
      });
    } else {
        console.log("El media_url esta vacio");
    }

}

function download_multiple_media(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    
    let medias_id = [];
    $.each(rows_selected, function(index, rowId){
        medias_id.push(rowId);
    });

    if(medias_id.length == 0){

        window.messages.error(__('No has seleccionado ningún archivo'));

    } else {
        
        $('#batch_media_download input[name="medias_id"]').val(JSON.stringify(medias_id));
        $('#batch_media_download')[0].submit();
       
    }

}

export function media_reload(){
    
    dt_media.ajax.reload();

}

export function media_force_reload(){

    dt_media.column(0).checkboxes.deselectAll();
    dt_media.ajax.reload();

}

// comments

function show_init_comments(){

    // datatable comments

    dt_comments = $('#comments_table').DataTable({
        ajax: {
            url: $('#comments_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_comments_actions },
            { data: 'created_at', orderable: true, searchable: true, render: datatables.render_datetime },
            { data: 'updated_at', orderable: true, searchable: true, render: datatables.render_datetime },
            { data: 'author_id', orderable: true, searchable: true },
            { data: 'content_id', orderable: true, searchable: true },
        ],
        order: [[3, 'desc']],
    });

    dt_comments.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_comments"]').click(batch_delete_comments);
    });

}

function render_comments_actions(data, type, row){

    const url_info = ($("#comments_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

function batch_delete_comments(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.comments.batch_delete'].replace('{microsite}', microsite_id);
    
    let comments_id = [];
    $.each(rows_selected, function(index, rowId){
        comments_id.push(rowId);
    });
    
    if(comments_id.length == 0){

        window.messages.error(__('No has seleccionado ninguna comentario'));

    } else {

        const title = __('Eliminar comentarios');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un comentario.|[2,*] Estás a punto de eliminar :count comentarios.', comments_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    for(let comment_id of comments_id){
                        formData.append('comments_id[]', comment_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );
    }
}